import NewselaGlobalLayout from "@/base";
import NotAllowedError from "@/errors/NotAllowedError";
import NotLoggedInError from "@/errors/NotLoggedInError";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

// Only allow users with a teacher record to access the directory
export const useSettingsDirectoryPrivileges = (user) => {
  return user?.teacher;
};

const withSettingsDirectoryPrivileges = (ComponentToWrap) => {
  const WrappedWithApprovedAdmin = () => {
    const { data: user } = useUser();
    const { isAuthenticatedUser } = getUserProperties(user);
    const hasPermissionToView = useSettingsDirectoryPrivileges(user);

    if (!isAuthenticatedUser)
      return <NewselaGlobalLayout mainContents={<NotLoggedInError />} />;
    if (!hasPermissionToView)
      return <NewselaGlobalLayout mainContents={<NotAllowedError />} />;
    return <ComponentToWrap />;
  };

  return WrappedWithApprovedAdmin;
};

export default withSettingsDirectoryPrivileges;
